import { styled } from '@nextiva/next-ui-components';

import colors from 'styles/application/_base/_variables.scss';

export const SectionSaveCancelStyles = styled('div')`
  .MuiButton-root {
    border-radius: 4px;
  }

  .MuiButton-contained {
    background-color: ${colors.cancelBtnBg};
  }

  .MuiButton-containedPrimary {
    background-color: ${colors.primaryBlue};
    color: ${colors.white};
  }

  .MuiButton-contained:hover {
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
      0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    background-color: #d5d5d5;
  }

  .MuiButton-contained:active {
    box-shadow: 0px 5px 5px -3px rgb(0 0 0 / 20%),
      0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%);
  }

  .section-save-cancel {
    .MuiDrawer-paper {
      margin-left: 327px;
      overflow: hidden;
    }

    &__container {
      display: flex;
      justify-content: flex-end;
      height: 72px;
      margin-right: 6%;
    }

    &__button-container {
      display: inline-block;
      margin-top: 16px;
      margin-right: 16px;
      text-align: center;
      font-weight: 500;

      &__button {
        min-width: 114px !important;
        height: 40px;
        box-shadow: none;

        &.info:active {
          box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
            0px 8px 10px 1px rgba(0, 0, 0, 0.14),
            0px 3px 14px 2px rgba(0, 0, 0, 0.12);
        }

        &.info:hover {
          background-color: rgb(0, 66, 165);
          box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
            0px 4px 5px 0px rgba(0, 0, 0, 0.14),
            0px 1px 10px 0px rgba(0, 0, 0, 0.12);
        }
      }
    }
  }

  .save-spinner {
    margin-left: 16px;
    position: absolute;
  }
`;
